import React, { useState } from 'react';

import { Position } from '../../../shared/modal/PositionModal';
import { IconButton } from '../../../shared/button/IconButton';
import { Settings } from '../../../shared/icons';
import { MLDataSettingsModal } from './MLDataSettingsModal';

interface MlDatasetSettingsButtonProps {
    reorderCheckedQueries: boolean;
    setReorderCheckedQueries: (value: boolean) => void;
    includePreviousQueries: boolean;
    setIncludePreviousQueries: (value: boolean) => void;
    showMoveCheckedQueries: boolean;
}

export const MlDatasetSettingsButton: React.FC<MlDatasetSettingsButtonProps> = ({
    reorderCheckedQueries,
    setReorderCheckedQueries,
    includePreviousQueries,
    setIncludePreviousQueries,
    showMoveCheckedQueries
}) => {
    const [position, setPosition] = useState<Position | null>(null);
    const [listViewSettingsOpen, setListViewSettingsOpen] = useState<boolean>(false);

    const openSettings = (x: number, y: number) => {
        setPosition({ x, y });
        setListViewSettingsOpen(true);
    };

    const closeSettings = () => {
        setPosition(null);
        setListViewSettingsOpen(false);
    };

    return (
        <>
            <IconButton
                onClick={e => openSettings(e.clientX - 20, e.clientY - 40)}
                icon={Settings} />
            <MLDataSettingsModal
                showMoveCheckedQueries={showMoveCheckedQueries}
                position={position}
                isOpen={listViewSettingsOpen}
                closeModal={closeSettings}
                reorderCheckedQueries={reorderCheckedQueries}
                setReorderCheckedQueries={setReorderCheckedQueries}
                includePreviousQueries={includePreviousQueries}
                setIncludePreviousQueries={setIncludePreviousQueries}
                testId='ml-data-settings-modal'
            />
        </>
    );
};
